/**
 * Edge Type Enum
 * Defines all relationship types between entities in the dependency graph
 */
export enum EdgeType {
    // Service relationships
    SERVICE_TO_FUNCTION = "SERVICE_TO_FUNCTION",
    SERVICE_TO_SERVICE = "SERVICE_TO_SERVICE",
    SERVICE_TO_MODEL = "SERVICE_TO_MODEL",
    
    // Middleware relationships
    MIDDLEWARE_TO_FUNCTION = "MIDDLEWARE_TO_FUNCTION",
    MIDDLEWARE_TO_SERVICE = "MIDDLEWARE_TO_SERVICE",
    MIDDLEWARE_TO_MODEL = "MIDDLEWARE_TO_MODEL",
    
    // Endpoint relationships
    ENDPOINT_TO_FUNCTION = "ENDPOINT_TO_FUNCTION",
    ENDPOINT_TO_MIDDLEWARE = "ENDPOINT_TO_MIDDLEWARE",
    ENDPOINT_TO_SERVICE = "ENDPOINT_TO_SERVICE",
    ENDPOINT_TO_MODEL = "ENDPOINT_TO_MODEL",
    
    // Model relationships (for references)
    MODEL_TO_MODEL = "MODEL_TO_MODEL",
}

/**
 * Edge Type Labels (for UI display)
 */
export const EdgeTypeLabel: Record<EdgeType, string> = {
    [EdgeType.SERVICE_TO_FUNCTION]: "Service → Function",
    [EdgeType.SERVICE_TO_SERVICE]: "Service → Service",
    [EdgeType.SERVICE_TO_MODEL]: "Service → Model",
    [EdgeType.MIDDLEWARE_TO_FUNCTION]: "Middleware → Function",
    [EdgeType.MIDDLEWARE_TO_SERVICE]: "Middleware → Service",
    [EdgeType.MIDDLEWARE_TO_MODEL]: "Middleware → Model",
    [EdgeType.ENDPOINT_TO_FUNCTION]: "Endpoint → Function",
    [EdgeType.ENDPOINT_TO_MIDDLEWARE]: "Endpoint → Middleware",
    [EdgeType.ENDPOINT_TO_SERVICE]: "Endpoint → Service",
    [EdgeType.ENDPOINT_TO_MODEL]: "Endpoint → Model",
    [EdgeType.MODEL_TO_MODEL]: "Model → Model",
};

/**
 * Get edge types that connect to a specific entity type
 */
export function getEdgeTypesForEntityType(entityType: string): EdgeType[] {
    const edges: EdgeType[] = [];
    
    switch (entityType) {
        case "service":
            edges.push(
                EdgeType.SERVICE_TO_FUNCTION,
                EdgeType.SERVICE_TO_SERVICE,
                EdgeType.SERVICE_TO_MODEL
            );
            break;
        case "middleware":
            edges.push(
                EdgeType.MIDDLEWARE_TO_FUNCTION,
                EdgeType.MIDDLEWARE_TO_SERVICE,
                EdgeType.MIDDLEWARE_TO_MODEL
            );
            break;
        case "endpoint":
            edges.push(
                EdgeType.ENDPOINT_TO_FUNCTION,
                EdgeType.ENDPOINT_TO_MIDDLEWARE,
                EdgeType.ENDPOINT_TO_SERVICE,
                EdgeType.ENDPOINT_TO_MODEL
            );
            break;
        case "function":
            // Functions don't have outgoing edges, only incoming
            break;
        case "model":
            edges.push(EdgeType.MODEL_TO_MODEL);
            break;
    }
    
    return edges;
}

/**
 * Check if edge type is valid
 */
export function isValidEdgeType(type: string): type is EdgeType {
    return Object.values(EdgeType).includes(type as EdgeType);
}

